export const LS_CTRL_CLICK_TABLE_FILTER_TIP = "ctrl-click-table-filter-tip"
